import React, { FC, memo, useState } from "react";
import { If, Then } from "react-if";
import { Box, Grid, GridItem, Select, SimpleGrid } from "@chakra-ui/react";
import ProductCardVerticalCenterItem from "@modules/Layout/components/ProductCardVerticalCenterItem";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";
import LoadingScreen from "@modules/Layout/components/LoadingScreen";
import usePaginatedProduct from "../hooks/usePaginatedProduct";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import useProductCategoryPageAttr from "../hooks/useProductCategoryPageAttr";

const ProductCards: FC = () => {
  const { data: pageAttr } = useProductCategoryPageAttr();
  const [sortByValue, setSortByValue] = useState<string>("createdAt");

  const is_show_sort_by = pageAttr?.data?.attributes?.is_show_sort_by;

  const { currentPage, handlePageChange, productQuery } =
    usePaginatedProduct(sortByValue);

  if (productQuery.isLoading) {
    return <LoadingScreen />;
  }

  const result = productQuery?.data?.results;
  const pagination = productQuery?.data?.pagination;

  const handleSortBy = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const sortBy = e.target.value;
    setSortByValue(sortBy);
    handlePageChange(1);
  };

  return (
    <ResponsiveContainer>
      <Box py="10">
        <If condition={result!.length > 0}>
          <Then>
            <If condition={is_show_sort_by}>
              <Then>
                <Grid templateColumns="repeat(4, 1fr)" gap={4} py={7}>
                  <GridItem
                    colSpan={{ base: 4, md: 2, xl: 1 }}
                    pr={{ base: 0, md: 10, lg: 20, xl: 0 }}
                  >
                    <Box mb={7} maxW={{ base: "100%", md: "320px" }}>
                      <Select value={sortByValue} onChange={handleSortBy}>
                        <option value="createdAt">
                          Sort by Recently Added
                        </option>
                        <option value="name">Sort by Name</option>
                      </Select>
                    </Box>
                  </GridItem>
                </Grid>
              </Then>
            </If>

            <SimpleGrid
              columns={{ base: 1, md: 2, lg: 4 }}
              spacing={4}
              flex={1}
            >
              {result?.map((item, index) => {
                const image = item?.image;
                const dataItem = {
                  name: item?.name,
                  description: item.description,
                  label: item.label,
                  slug: `products/${item.slug}`,
                  isNew: item.is_new,
                  image: {
                    data: {
                      id: index,
                      attributes: { ...image },
                    },
                  },
                };
                return (
                  <Box key={index}>
                    <ProductCardVerticalCenterItem item={dataItem} />
                  </Box>
                );
              })}
            </SimpleGrid>
          </Then>
        </If>
      </Box>

      <Box mb={12}>
        <Pagination
          className="p2"
          total={pagination?.total}
          pageSize={pagination?.pageSize}
          current={currentPage}
          onChange={handlePageChange}
          hideOnSinglePage
        />
      </Box>
    </ResponsiveContainer>
  );
};

export default memo(ProductCards);
